/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { IWizardOrderTemplateTranslation } from '../../types/wizards/orderTemplate';

export const initWizardOrderTemplateTranslation: IWizardOrderTemplateTranslation = {
    title: '',
    steps: {
        TemplateSelectionDataStep: '',
        TemplateParametersConfirmStep: '',
    },
    error: {
        codes: {},
        defaultMessage: '',
    },
};
